import React, { FC, PropsWithChildren, useCallback, useState } from 'react'

import { ModalContext } from './modalContext'

export const ModalProvider: FC<PropsWithChildren> = ({ children }) => {
  const [openModalsCount, setOpenModalsCount] = useState(0)

  const markModalAsOpened = useCallback(() => setOpenModalsCount((count) => count + 1), [])
  const markModalAsClosed = useCallback(
    () => setOpenModalsCount((count) => Math.max(count - 1, 0)),
    []
  )

  React.useEffect(() => {
    document.body.style.overflow = openModalsCount > 0 ? 'hidden' : ''
  }, [openModalsCount])

  return (
    <ModalContext.Provider value={{ markModalAsOpened, markModalAsClosed }}>
      {children}
    </ModalContext.Provider>
  )
}
